// ATW-COLLECTION-EXTRAS v2
// "Vedi altro" load-more continuo + random shuffle product cards
(function () {
  // ─── Load more (Vedi altro) ───
  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('[data-atw-load-more]');
    if (!btn) return;
    e.preventDefault();
    const url = btn.getAttribute('data-next-url');
    if (!url || btn.dataset.loading === '1') return;

    btn.dataset.loading = '1';
    btn.disabled = true;
    const original = btn.textContent;
    btn.textContent = 'Caricamento…';

    try {
      const res = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newGrid = doc.getElementById('product-grid');
      const curGrid = document.getElementById('product-grid');
      if (newGrid && curGrid) {
        Array.from(newGrid.children).forEach(function (li) {
          li.removeAttribute('data-cascade');
          li.style.removeProperty('--animation-order');
          curGrid.appendChild(li);
        });
      }
      const newBtn = doc.querySelector('[data-atw-load-more]');
      const nextUrl = newBtn && newBtn.getAttribute('data-next-url');
      if (nextUrl) {
        btn.setAttribute('data-next-url', nextUrl);
        btn.disabled = false;
        btn.textContent = original;
        btn.dataset.loading = '0';
      } else {
        const wrap = btn.closest('.atw-load-more-wrap');
        if (wrap) wrap.remove();
      }
      // ponytail: NON riscrivere l'URL con ?page=N — al refresh il browser
      // ricaricherebbe da quella pagina, perdendo la 1 e saltando lo shuffle.
      // Per una griglia random il refresh deve ripartire da pagina 1.
    } catch (err) {
      btn.disabled = false;
      btn.textContent = original;
      btn.dataset.loading = '0';
      console.error('[ATW] load-more failed', err);
    }
  });

  // ─── shuffle product cards (solo prima pagina, ordine non forzato) ───
  function shuffleNodeList(parent) {
    const cards = Array.from(parent.children);
    for (let i = cards.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      parent.appendChild(cards[j]);
      cards.splice(j, 1);
    }
    cards.forEach(function (c) { parent.appendChild(c); });
  }

  function shuffleProducts() {
    const u = new URL(window.location.href);
    if (parseInt(u.searchParams.get('page') || '1', 10) > 1) return;
    const sortBy = u.searchParams.get('sort_by') || '';
    if (sortBy && sortBy !== 'manual') return;
    const grid = document.getElementById('product-grid');
    if (grid) shuffleNodeList(grid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', shuffleProducts);
  } else {
    shuffleProducts();
  }
})();
